import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu, Modal} from "antd";
import {v4} from "uuid";
import ApiService from "../../../core/service/api-service";
import {t} from "i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import KosStatusEnum from "../../../enums/KosStatusEnum";

export default function TeletipRowMenu({text, row}) {
    const {refreshDataGrid} = useDataGrid()

    const hasKos = row.teletipStatus !== KosStatusEnum.NO_KOS && row.teletipStatus !== KosStatusEnum.KOS_REMOVED;

    const downloadKos = async () => {
        const res = await ApiService.Teletip.DownloadKos(row.id);
        if(res.success) {
            ApiService.downloadFile(res.data, res.fileName);
        }
    }

    const removeKos = () => {
        Modal.confirm({
            title: t('Remove Kos'),
            content: t('The KOS file will be deleted. Continue?'),
            okText: t('Remove Kos'),
            cancelText: t('Cancel'),
            onOk: async () => {
                const res = await ApiService.Teletip.RemoveKos([row.id]);
                if(res.success) {
                    refreshDataGrid()
                }
            }
        });
    }

    return (
        <RowMenu text={text}>
            <Menu>
                <Menu.Item
                    key={v4()}
                    onClick={async () => {
                        const res = await ApiService.Teletip.MakeKos([{studyId: row.studyId}]);
                        if(res.success) {
                            refreshDataGrid()
                        }
                    }}
                >
                    {t('Make Kos')}
                </Menu.Item>
                <Menu.Item
                    key={v4()}
                    onClick={async () => {
                        const res = await ApiService.Teletip.SendKos([row.id]);
                        if(res.success) {
                            refreshDataGrid()
                        }
                    }}
                >
                    {t('Send Kos')}
                </Menu.Item>
                <Menu.Item
                    key={v4()}
                    disabled={!hasKos}
                    onClick={downloadKos}
                >
                    {t('Download Kos')}
                </Menu.Item>
                <Menu.Item
                    key={v4()}
                    disabled={!hasKos}
                    onClick={removeKos}
                >
                    {t('Remove Kos')}
                </Menu.Item>
            </Menu>
        </RowMenu>
    )
}
